module.exports = __webpack_public_path__ + "img/wulianwang (7).0302a902.png";